// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PhoneFilledSvg from "@ant-design/icons-svg/es/asn/PhoneFilled";
import AntdIcon from '../components/AntdIcon';

var PhoneFilled = function PhoneFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PhoneFilledSvg
  }));
};

PhoneFilled.displayName = 'PhoneFilled';
export default React.forwardRef(PhoneFilled);